const actions = {
  setProtocol({commit}, protocolData) {
    commit('setProtocol', protocolData);
  },
  setProtocolVersion({commit}, version) {
    commit('setProtocolVersion', version);
  },

}

export default actions



// WEBPACK FOOTER //
// ./src/modules/dashboardParent/vuex/actions.js